import React from "react";
import LoginForm from "./../Auth/login";
import { Link } from "react-router-dom";

const LoginPage = () => {
  return (
    <div style={{ width: "100%" }}>
      <div className="t-title">
        <h1>Iniciar sesión</h1>
      </div>
      <div className="main">
        <LoginForm />
        <p className="desc">
          <Link to="/">Volver</Link>
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
